import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './Address.css';

export const Address: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['address']}>
      <ArticleParagraph2 color="current_color" as="span">
        {children}
      </ArticleParagraph2>
    </div>
  );
};
